import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ImportConflict } from '../../../../models/import-conflict';
import translateJson from "../../../../../translate.json";

@Component({
  selector: 'conflict-component',
  templateUrl: './conflict.component.html',
  styleUrls: ['./conflict.component.css']
})
export class ConflictComponent implements OnInit {

  @Input() conflict: ImportConflict;
  @Input() index: number;
  @Input() control: FormControl;

  private inputPlaceholder: string = '';
  
  private mainOptionSelected: boolean =  true;
  private otherSelected: boolean = false;
  
  private i18 = translateJson.i18;
  
  constructor() {    
  }

  ngOnInit() {
    this.inputPlaceholder = `${this.conflict.title.toLowerCase()}`
  }

  onOtherSelected() {
    this.control.reset()
    this.otherSelected = true;
    this.mainOptionSelected = false;
  }

  onMainOptionSelected() {
    this.otherSelected = false;
    this.mainOptionSelected = true;
  }
}